import { useState } from 'react';
import { Link } from 'react-router-dom';
import Card from '../components/Card.jsx';
import Button from '../components/Button.jsx';
import { useAuth } from '../context/AuthContext.jsx';
import './auth.css';

export default function ForgotPassword() {
  const { resetPassword, configured } = useAuth();

  const [email, setEmail] = useState('');
  const [fieldError, setFieldError] = useState('');
  const [formError, setFormError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  function validate() {
    if (!email.trim()) {
      setFieldError('Enter your email.');
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setFieldError('Enter a valid email.');
      return false;
    }
    setFieldError('');
    return true;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setFormError('');
    if (!validate()) return;
    setSubmitting(true);
    try {
      await resetPassword(email.trim());
      setSent(true);
    } catch (err) {
      setFormError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="aq-public">
      <header className="aq-public-nav">
        <Link to="/" className="aq-public-brand">
          <span className="aq-wordmark">
            Alpha<span className="aq-wordmark-accent">Qap</span>
          </span>
        </Link>
        <nav className="aq-public-nav-actions">
          <Button as={Link} to="/login" variant="ghost" size="sm">
            Log in
          </Button>
        </nav>
      </header>

      <div className="aq-auth-shell">
        <Card className="aq-auth-card">
          <Link to="/" className="aq-auth-back">
            ← Back to home
          </Link>
          <div>
            <h1 className="aq-auth-title heading">Reset your password</h1>
            <p className="aq-auth-sub">
              Enter the email on your account and we'll send you a reset link.
            </p>
          </div>

          {!configured ? (
            <div className="aq-auth-not-configured">
              Password reset isn't configured on this deployment yet. The Firebase project vars
              (<code>VITE_FIREBASE_*</code>) haven't been set for this environment — see the
              README for the deploy checklist.
            </div>
          ) : sent ? (
            <div className="aq-auth-alert aq-auth-alert--success">
              Check your email — if an account exists for <b>{email.trim()}</b>, a reset link is
              on its way.
            </div>
          ) : (
            <form className="aq-auth-form" onSubmit={handleSubmit} noValidate>
              {formError && <div className="aq-auth-alert aq-auth-alert--error">{formError}</div>}

              <div className={`aq-auth-field ${fieldError ? 'aq-auth-field-error' : ''}`}>
                <label htmlFor="forgot-email">Email</label>
                <input
                  id="forgot-email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                />
                {fieldError && <span className="aq-auth-field-hint aq-auth-field-hint--error">{fieldError}</span>}
              </div>

              <Button type="submit" variant="primary" className="aq-auth-submit" disabled={submitting}>
                {submitting ? 'Sending…' : 'Send reset link'}
              </Button>
            </form>
          )}

          <div className="aq-auth-links">
            <span>
              Remembered it? <Link to="/login">Log in</Link>
            </span>
            <span>
              Need an account? <Link to="/signup">Sign up</Link>
            </span>
          </div>
        </Card>
      </div>
    </div>
  );
}
